var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgHidden = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 12,
    viewBox: "0 0 21 12",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.93989 1.15877C2.75115 0.63974 2.17739 0.371983 1.65835 0.560723C1.13932 0.749462 0.871565 1.32323 1.0603 1.84226C1.34215 2.61734 1.91882 3.65762 2.82206 4.66232L0.875403 6.21965C0.444141 6.56466 0.37422 7.19395 0.719229 7.62521C1.06424 8.05647 1.69353 8.12639 2.12479 7.78138L4.31846 6.02645C5.04019 6.5625 5.88188 7.03633 6.85014 7.38531L6.03857 10.2258C5.88685 10.7568 6.19434 11.3103 6.72538 11.462C7.25641 11.6138 7.8099 11.3063 7.96162 10.7752L8.79046 7.87432C9.33014 7.95616 9.89978 8.00052 10.5001 8.00052C10.9263 8.00052 11.3352 7.97818 11.7273 7.93594L11.8921 8.51267L12.5386 10.7752C12.6903 11.3063 13.2438 11.6138 13.7748 11.462C14.3059 11.3103 14.6133 10.7568 14.4616 10.2258L13.8152 7.96323L13.6905 7.52671C14.5766 7.24421 15.3497 6.85197 16.0185 6.3959L18.3754 8.28138C18.8067 8.62639 19.436 8.55647 19.781 8.12521C20.126 7.69395 20.0561 7.06466 19.6248 6.71965L17.5566 5.06512C18.6107 3.91976 19.2183 2.66754 19.4649 1.76363C19.6102 1.23081 19.296 0.681068 18.7632 0.535752C18.2304 0.390437 17.6806 0.704575 17.5353 1.2374C17.1193 2.76286 15.1296 6.00052 10.5001 6.00052C5.8401 6.00052 3.5085 2.72244 2.93989 1.15877Z"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgHidden);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/Hidden.8d184788b8ab84baa36fa32adeb1d4fe.svg";